export default "__VITE_ASSET__4fff3928__"